var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8965_4432)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 49.4001C38.9234 49.4001 49.4001 38.9237 49.4001 26C49.4001 13.0765 38.9237 2.59994 26 2.59994C13.0765 2.59994 2.59994 13.0765 2.59994 26C2.59994 38.9234 13.0765 49.4001 26 49.4001ZM26 52C40.3592 52 52 40.3592 52 26C52 11.6405 40.3592 0 26 0C11.6405 0 0 11.6405 0 26C0 40.3592 11.6405 52 26 52Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7567 26.0013L20.8004 18.0305V33.9723L32.7567 26.0013ZM35.1723 24.487C36.253 25.2075 36.253 26.7953 35.1723 27.5158L21.0298 36.9443C19.8204 37.7507 18.2002 36.8834 18.2002 35.4298V16.573C18.2002 15.1194 19.8204 14.2524 21.0298 15.0588L35.1723 24.487Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8965_4432"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/Play.5b6ac47ce96a2ef6d8873a52910286bf.svg";
export { ForwardRef as ReactComponent };